import React from "react";
import "./NavbarLoader.css";

const NavbarLoader = () => {
  return <span className="nav-loader"></span>;
};

export default NavbarLoader;
